(() => {
  const PARAGLIDING_URL = '/collections/paragliding';
  const ICONS = {
    'activity-bergsteigen_und_trekking':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-bergsteigen_und_trekking.svg?v=1744272076',
    'paragliding':'https://cdn.shopify.com/s/files/1/0621/0060/2968/files/activity-paragliding-icon.png?v=1786059472',
    'activity-camping':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-camping.svg?v=1743756754',
    'activity-urban_outdoor':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-urban-outdoor.svg?v=1743756759',
    'activity-nordic_walking':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-nordic-walking.svg?v=1743756727',
    'activity-ski_alpin':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-ski-alpin.svg?v=1743756767',
    'activity-fitness_und_yoga':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-fitness_und_yoga.svg?v=1744277505',
    'activity-klettern_und_bouldern':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-klettern_und_bouldern.svg?v=1744277261',
    'activity-laufsport':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-laufsport.svg?v=1743756729',
    'activity-radsport':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-radsport.svg?v=1743756724',
    'activity-skitour':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-skitour.svg?v=1743756764',
    'activity-snowboard':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-snowboard.svg?v=1743756761',
    'activity-wassersport':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-wassersport.svg?v=1743756756',
    'activity-reisen':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-reisen.svg?v=1743756748',
    'activity-langlauf':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-langlauf.svg?v=1743756777',
    'activity-schneeschuhwandern':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-schneeschuh-touren.svg?v=1744278152',
    'activity-golf':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-golf.svg?v=1743756774',
    'activity-expedition':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-expedition.svg?v=1743756739',
    'activity-eisklettern':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-eisklettern.svg?v=1743756742',
    'activity-jagen_und_angeln':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-jagen_und_angeln.svg?v=1744277219',
    'activity-skate_und_streetsport':'https://cdn.shopify.com/s/files/1/0621/0060/2968/collections/iconset-skate_und_streetsport.svg?v=1744277140'
  };

  const handleOf = (href) => {
    try {
      const match = new URL(href, location.origin).pathname.match(/^\/collections\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  };

  const isParaglidingCard = (card) => {
    if (!card) return false;
    const label = (card.textContent || '').trim().toLocaleLowerCase('de');
    return handleOf(card.getAttribute('href')) === 'paragliding' || label === 'paragliding';
  };

  const apply = (root = document) => {
    const context = root?.querySelectorAll ? root : document;
    context.querySelectorAll('.ps-mega__panel[data-panel$=":activity"] .ps-mega__activity-card[href]').forEach((card) => {
      let handle = handleOf(card.getAttribute('href'));
      if (isParaglidingCard(card)) {
        card.setAttribute('href', PARAGLIDING_URL);
        card.dataset.psParagliding = 'true';
        handle = 'paragliding';
      }

      const source = ICONS[handle];
      if (!source) return;
      card.hidden = false;
      card.removeAttribute('hidden');
      const box = card.querySelector('.ps-mega__activity-icon');
      if (!box || box.dataset.liveIcon === source) return;
      const image = document.createElement('img');
      image.src = source;
      image.alt = '';
      image.loading = 'lazy';
      image.width = 120;
      image.height = 120;
      box.replaceChildren(image);
      box.dataset.liveIcon = source;
    });
  };

  document.addEventListener('click', (event) => {
    const card = event.target.closest?.('.ps-mega__panel[data-panel$=":activity"] .ps-mega__activity-card');
    if (!isParaglidingCard(card)) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(PARAGLIDING_URL);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => apply(document), { once: true });
  else apply(document);
  document.addEventListener('shopify:section:load', (event) => apply(event.target));
  document.addEventListener('pointerover', (event) => {
    if (event.target.closest?.('[data-category="activity"]')) setTimeout(() => apply(document), 0);
  });
})();
